import React, { useEffect ,memo, useRef, useState, createElement} from "react";
import { sendCommand } from "../../support/LocalCommand";
import { getBlock, getBlockRange, getSubscriptTrail, makeUniversalBlockKey, modelStore, remakeLineSizes } from "../storage/model";
import $, { get } from "jquery"
import { Block } from "./EBlock";
import { createAndExecuteMetaChange, executeBlockContentChange, makeAndExecuteBlockLevelUpdate, makeAndExecuteDeleteArbitraryBlocks, makeAndExecuteInsertBlockUpdate, makeBlockTextUpdate, makeRetypeBlockUpdate } from "../storage/changes";
import { access, isArray, isNumber, logTimestamp, ToggleButton, useProperty } from "../../support/general";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { copyRangeToClipboard, getBlocksFromClipboard } from "../storage/clipboard";
import { doChange, makeChange, undoChange } from "../storage/changes_admin";
import { doDefaultKeyHandling, insertTable, NoteTable } from "./ETable";
import { AutosizeTextArea } from "../../support/autotext";
import { onMetaChanged, onTextChanged } from "./Fields";
import { setMouseMoveHandler } from "./Column";
import { getNodeIdParent } from "./EPagedSubscript";
import { hidePopup, showMenu, showPopup } from "../../support/popup";
import { colorCodes, ColorCodeSelector } from "../../support/UxBitsAndPieces";
import { showDialog } from "../../support/modal_dialog";



export function EFolder({scriptId,subscriptId}){

    const [getTop,setTop] = useProperty(0);
    const [getLeft,setLeft] = useProperty(0);
    const [getZoom,setZoom] = useProperty(0.7);
    const [getSelected,setSelected] = useProperty(null);
    const [getMouseMode,setMouseMode] = useProperty('grab');
    const [getOverBlockId,setOverBlockId] = useProperty(0);
    const [getSelectionRange,setSelectionRange] = useProperty(null);
    const [getHighlightedBlockIds,setHighlightedBlockIds] = useProperty(null);

    const keyboardRef = useRef();

    var orderedIds = modelStore.useSelector(state=>{
        return state.access(["model","Script",scriptId,"subscripts",subscriptId,"orderedIds"],[]);
    },subscriptId);

    var postIts = [];

    var selected = getSelected()??{};
    var {selectedBlockIds,selectedBlockId,selectedCount}  = getSingleSelected(selected);

    var singleSelectedBlock = selectedBlockId?getBlock(scriptId,selectedBlockId):null;
    var selectedGroup = singleSelectedBlock?.meta?.group??"";
    var zoom = getZoom();

    var detailBlockId = 0;
    if (getOverBlockId()){
        detailBlockId = getOverBlockId();
    } else if (selectedBlockIds.length>1 && selectedBlockIds.length<=3) {
        detailBlockId = selectedBlockIds;
    } else  if (selectedBlockId) {
        detailBlockId = selectedBlockId;
    }

    var highlightedBlocks = getHighlightedBlockIds()??{};

    $.each(orderedIds,(index,blockId)=>{
        postIts.push(<EPostIt
            key = {blockId}
            scriptId = {scriptId}
            subscriptId={subscriptId}
            blockId = {blockId}
            index= {index}
            zoom = {getZoom()}
            isSelected = {!!selected[blockId]}
            onHeaderClicked = {onPostItHeaderClicked}
            onPostItContextMenu = {onPostItContextMenu}
            activeGroup = {selectedGroup}
            onEnterPostIt = {onEnterPostIt}
            onLeavePostIt = {onLeavePostIt}   
            isHighlighted = {!!highlightedBlocks[blockId]}         
        />)
    })

    function onPostItHeaderClicked(e,blockId,isSelected){

        if (!isSelected){
            var newSelected = e.shiftKey?$.extend({},getSelected()):{};
            newSelected[blockId]=true;
            setSelected(newSelected);
        }
        
        if (e.button==2){
            return false;
        } else {
            var draggers = [];
            var selected = getSelected()??{};
            $.each(selected,(blockId,dummy)=>{
                var block = modelStore.access(["model","Block",makeUniversalBlockKey(scriptId,blockId)]);
                draggers.push({
                    blockId : block.id,
                    startTop : block?.meta?.top??100,
                    startLeft : block?.meta?.left??100,
                })
            });

            setMouseMoveHandler(e,{
                onMove : function(e,deltaX,deltaY){
                    $.each(draggers,(d,dragger)=>{
                        const newValues = {
                            left : Math.round((dragger.startLeft + deltaX/zoom)/gridColWidth) * gridColWidth  ,
                            top : Math.round((dragger.startTop + deltaY/zoom)/gridRowHeight) * gridRowHeight ,
                        }

                        onMetaChanged(scriptId,subscriptId,dragger.blockId,newValues);
                    })
                }
            })
        }
    }
    function onBlockFocussedInDetail(blockId){
        
        if (!blockId){
            setHighlightedBlockIds(null);
            return
        }
        var targetBlock = getBlock(scriptId,blockId);
        var targetGridCol = getGridColumn(targetBlock?.meta?.left??0);
        var targetGridRow = getGridRow(targetBlock?.meta?.top??0);
        
        var sequenceBlock = null;
        var headerBlock = null;

        $.each(orderedIds,(b,bId)=>{
            var block = getBlock(scriptId,bId);
            var blockRow = getGridRow(block.meta.top);
            var blockCol = getGridColumn(block.meta.left);
            
            if (block.meta.isHeader && blockCol==targetGridCol){
                headerBlock = block;
            }
            if (block.meta.isSequence && blockRow==targetGridRow){
                sequenceBlock = block;
            }
        });
        var highlightedBlocks = {};
        highlightedBlocks[blockId]=true;
        if (sequenceBlock){
            highlightedBlocks[sequenceBlock.id]=true;
        }
        if (headerBlock){
            highlightedBlocks[headerBlock.id]=true;
        }

        setHighlightedBlockIds(highlightedBlocks);
    }
    function onMouseDown(e){

        if (e.target===e.currentTarget && e.button!=2){
            keyboardRef.current?.focus();

            if(getMouseMode()=='grab'){

                var topAtMouseDown =getTop();
                var leftAtMouseDown =getLeft();
                
                setMouseMoveHandler(e,{
                    onMove : function(e,deltaX,deltaY){
                        setTop(topAtMouseDown+deltaY/zoom);
                        setLeft(leftAtMouseDown+deltaX/zoom);
                    },
                    onUp : function(e,deltaX,deltaY){
                        this.onMove(e,deltaX,deltaY);
                    },
                    cancel : function(e){

                    }
                })
            } else {
                
                 var offset = $('#wall_cork').offset();

                setSelectionRange({
                    top : (e.clientY-offset.top)/zoom,
                    left : (e.clientX-offset.left)/zoom,
                    width : 0,
                    height : 0,
                })

                setMouseMoveHandler(e,{
                    onMove : function(e,deltaX,deltaY){
                        var range = getSelectionRange();
                        setSelectionRange(
                            $.extend({},getSelectionRange(),{
                                width : deltaX / zoom,
                                height : deltaY / zoom,
                            })
                        )
                    },
                    onUp : function(e,deltaX,deltaY){
                        
                        var selectedBlocks = $.extend({},getSelected());
                        var range = getSelectionRange();
                        var rangeRight = range.left+ range.width;
                        var rangeBottom = range.top + range.height;

                        $.each(orderedIds,(i,blockId)=>{
                            var block = getBlock(scriptId,blockId);
                            var top = block.meta.top;
                            var left = block.meta.left;
                            
                            if (
                                left >= range.left &&
                                left <= rangeRight &&
                                top >= range.top &&
                                top <= rangeBottom 
                            ) {
                                selectedBlocks[block.id]=true;
                            }
                        })

                        setSelected(selectedBlocks);
                    },
                    cancel : function(e){
                        setSelectionRange(null);
                    }
                })
            }
            e?.stopPropagation();
            e?.preventDefault();
            if (!e.shiftKey){
                setSelected(null);
            }
        }
    }
    function onFocus(){
        var ii=0;
    }
    function onKeyUp(e){
        if (e.target===e.currentTarget){
            setMouseMode(e.shiftKey?"select":"grab"); 
        }
    }
    function onKeyDown(e){
        if (e.target===e.currentTarget){
            const {
                handled,
                key,
                qualifiers
            } = doDefaultKeyHandling(e,scriptId,subscriptId);

            if ( handled ) {
                e.stopPropagation();
                return;
            }

            if (key=='='&& qualifiers=="a---"){
                setZoom(getZoom()*1.5);
            } else if (key=='-'&& qualifiers=="a---"){
                setZoom(getZoom()/1.5);
            }

            // if ( key.length==1 && ( (qualifiers == "----") || (qualifiers == "---s") ) ){ 
            //     // simple character to be inserted into the text
            //     insertLetterIntoCell(scriptId,subscriptId,key);
            // } else if (key=="Enter" ) {
            //     insertEnterIntoCell(scriptId,subscriptId);
            // } else if (key=="Delete" ) {
            //     doDeletionInCell(scriptId,subscriptId);
            // } else if (key=="Backspace") {
            //     doBackspaceInCell(scriptId,subscriptId);
            // } else if (qualifiers == "--m-"){
            //     // do nothing but don't return
            // } else {
            //     return // don't stop default behavior
            // }
            
            setMouseMode(e.altKey?"grab":"select");
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function onDoubleClick(e){
         if (e.target===e.currentTarget){

            var offset = $('#wall_cork').offset();
            makeAndExecuteInsertBlockUpdate(scriptId,subscriptId,0,{
                text : '',
                type : 'postit',
                meta: {
                    top : (e.clientY-offset.top)/zoom,
                    left : (e.clientX-offset.left)/zoom,
                    width : 100
                }
            })
         }
    }
    function onPostItContextMenu(e,blockId){

        var at = {x:e.clientX,y:e.clientY};

        showMenu({at:at,items:[
            {
                name : 'Delete Postit(s)',
                onClick : ()=>{deletePostIt(blockId) }
            },{
                name : 'Color',
                onClick : ()=>{changePostitColor(at)}
            },{
                name : 'Duplicate',
                onClick : ()=>{duplicatePostIt(blockId)}
            }, {
                name : 'Column Summary',
                onClick : ()=>{showColumnSummary(blockId)}
            }, {
                name : 'Row Summary',
                onClick : ()=>{showRowSummary(blockId)}
            }
        ]})

        e.cancelBubble=true;
        e.returnValue=false;
        e.preventDefault();
        e.stopPropagation();                    
        return false;

        function showRowSummary(){

            showDialog({
                message : {tag:RowSummary,props:{scriptId,subscriptId,blockId}},
                cancel : 'Close',
            })

        }
        function changePostitColor(at){

            showPopup(
                {
                    at : at,
                    tag : ColorCodeSelector,
                    props : {
                        onSelected : onSelected,
                    }
                }
            );

            function onSelected(value){
                $.each(selected,(blockId,dummy)=>{
                    onMetaChanged(scriptId,subscriptId,blockId,'color',colorCodes[value])
                })
                hidePopup();
            }

        }

        function showColumnSummary(blockId){
            
            showDialog({
                message : {tag:ColSummary,props:{scriptId,subscriptId,targetBlockId:blockId}},
                cancel : 'Close',
            })

        }
        
    }
    function duplicatePostIt(blockId){
        var block = getBlock(scriptId,blockId);
        makeAndExecuteInsertBlockUpdate(scriptId,subscriptId,0,{
            text : block?.text??"",
            type : block.type,
            meta : {
                top : block?.meta?.top??0 + 50,
                left : block?.meta?.left??0 + 50,
                description : block?.meta?.description??"",
                group : block?.meta?.group??"",
            }
        })
    }
    function onEnterPostIt(blockId){
        setOverBlockId(blockId);
    }
    function onLeavePostIt(blockId){
        setOverBlockId(0);
    }
    function deletePostIt(blockId){
        var deletionBlockIds = [];
        var selected = getSelected()??{};
        $.each(selected,(blockId,dummy)=>{
            deletionBlockIds.push(blockId)
        });
        makeAndExecuteDeleteArbitraryBlocks(scriptId,subscriptId,deletionBlockIds);
    }
    function onSelectionRequested(blockId){
            var newSelected = {};
            newSelected[blockId]=true;
            setSelected(newSelected);
    }
    var selector = null;
    var selectionRange = getSelectionRange();
    if (selectionRange){
        selector = (<div
            style = {{
                position : 'absolute',
                border : 'solid 1px grey',
                backgroundColor : 'transparent',
                top : (selectionRange.top*zoom)+'px',
                left : (selectionRange.left*zoom)+'px',
                width : (selectionRange.width*zoom)+'px',
                height : (selectionRange.height*zoom)+'px',
            }}
        ><div></div></div>)
        console.log(selectionRange.width+","+selectionRange.height)
    }

    var top = getTop();
    var left = getLeft();
    var zoom = getZoom();
    var mouseMode = getMouseMode();

    return (<Col
        className=" noScrollBar"
        style={{
            // font: font, //'18px Courier, fixed',
            height : '100%',
            overflow : 'hidden',
            position : 'relative',
        }}
    >
        <div 
            key ={1}
            style={{
                width:'10000em',
                height:'10000em',
                marginLeft: 'auto',
                marginRight: 'auto',
                position : 'relative',
                cursor : (mouseMode=='grab')?'move':'default',
            }}
            onFocus={onFocus}
            ref = {keyboardRef}
            onMouseDown={onMouseDown} 
            onKeyDown={onKeyDown}
            onKeyUp = {onKeyUp}
            onDoubleClick = {onDoubleClick}
            tabIndex={-1}
        > 
            <div 
                id = "wall_cork"
                style={{
                    position:'absolute',
                    top: (top*zoom)+'px',
                    left: (left*zoom)+'px',
                    fontSize : Math.pow(zoom,0.5)+"em",
                    
                }}

            >
                {/* {"Subscript : " + subscriptId + " ("+getLeft()+","+getTop()+")"} */}
                {postIts}
                {selector}
            </div>
        </div>
        <BlockMetaDetails 
            key ={2}
            scriptId = {scriptId}
            subscriptId = {subscriptId}
            blockId = {detailBlockId}
            onSelectionRequested = {onSelectionRequested}
            onBlockFocussed = {onBlockFocussedInDetail}
            // selected = {selected}
        />
    </Col>)
}
const gridColWidth = 70;
const gridRowHeight = 50;

function getGridColumn(left){
    return Math.round(left/gridColWidth);
}
function getGridRow(top){
    return Math.round(top/gridRowHeight)
}
function EPostIt ({scriptId,subscriptId,blockId,style,zoom,index,isSelected,onHeaderClicked,onPostItContextMenu,activeGroup,onEnterPostIt,onLeavePostIt,isHighlighted}){

    var block = modelStore.useSelector(state=>{
        return state.access(["model","Block",makeUniversalBlockKey(scriptId,blockId)]);
    },subscriptId+"_"+blockId);

    var meta = modelStore.useSelector(state=>{
        return state.access(["model","Block",makeUniversalBlockKey(scriptId,blockId),"meta"]);
    },subscriptId+"_"+blockId);

    var text = modelStore.useSelector(state=>{
        return state.access(["model","Block",makeUniversalBlockKey(scriptId,blockId),"text"]);
    },subscriptId+"_"+blockId);

    var width = meta?.width??100;
    var height = meta?.height??100;
    var title = meta?.title??"Title";
    var value = meta?.description??"";
    var top = meta?.top??(index*50);
    var left = meta?.left??(index*50);
    var color = meta?.color??'#F8F8F8'

    width= isNumber(width)?width:100;

    function onChanged(newValue){
        onMetaChanged(scriptId,subscriptId,block,'description',newValue)
    }
    function gridTop(n){
        return getGridRow(n)*gridRowHeight;
    }
    function gridLeft(n){
        return getGridColumn(n)*gridColWidth;
    }
    function gridWidth(n){
        return (Math.round(n/70)*70)-5;
    }
    style = $.extend({
        width: gridWidth(width)*zoom+"px",
        height : (gridRowHeight-5)*zoom+"px",
        position : 'absolute',
        // border : isSelected?'solid 2px black':'solid 1px grey',
        top : gridTop(top)*zoom+'px',
        left : gridLeft(left)*zoom+'px',
        minHeight : (10*zoom)+'px',
    },style);

    // if ( activeGroup  ) {
    //     if ( block?.meta?.group == activeGroup ) {
    //         // style.outline = (10*zoom)+'px solid red';
    //     }    
    // }

    if (isHighlighted){
        style.outline = '1px solid red';
    }

    function onMouseDownOnTitle(e){
        
        e.stopPropagation();
        e.preventDefault();
    
        if (onHeaderClicked){
            return onHeaderClicked(e,blockId,isSelected)
        }
        return true;
    }
    function onResizeMouseDown(e){
        
        var widthAtMouseDown = width;
        
        setMouseMoveHandler(e,{
            onMove : function(e,deltaX,deltaY){
                onMetaChanged(scriptId,subscriptId,blockId,'width',widthAtMouseDown+deltaX/zoom)
            },
            onUp : function(e,deltaX,deltaY){
                this.onMove(e,deltaX,deltaY);
            },
            cancel : function(e){
            }
        })

        e?.stopPropagation();
        e?.preventDefault();
    }
    function onContextmenu(e){
        onPostItContextMenu(e,blockId);
    }
    function onTitleDoubleClick(e){
        
        var block = getBlock(scriptId,blockId);
        var newName = block?.text??"";

        showDialog({
            title : "Rename '"+ text + "'",
            message : { tag:Rename , props:{block,onNameChanged:name=>{newName=name}} },
            ok : true,
            onOk : ()=>{
                onTextChanged(scriptId,subscriptId,blockId,newName);
            },
            cancel : true
        })

        function Rename({block,onNameChanged}){
            const [getValue,setValue] = useProperty(block?.text??"")

            function onChange(e){
                setValue(e.target.value);
                onNameChanged(getValue());
            }

            return (<input autoFocus  type="text" value={getValue()} onChange={onChange} />)
        }

    }
    
    var diameter = gridRowHeight*zoom*0.75;

    var content = text?(
        <div
            key = {1}
            style ={{
                width : '100%',
                height : '100%',
                backgroundColor : color,
                cursor : 'move',
                position : 'relative',
                fontSize : 9 * zoom,
                border : isSelected?'solid 2px black':'solid 1px grey',
                padding : 0,
                margin : 0,
            }}

        ><p
            style={{
                margin: 0,
                padding : 0,
                position: 'absolute',
                top: '50%',
                left: '50%',
                MsTransform: 'translate(-50%, -50%)',
                transform: 'translate(-50%, -50%',
                lineHeight: '130%',
            }}
        >{text}</p></div>
    ):(
        <div
            style ={{
                border : isSelected?'solid 2px black':'solid 1px grey',
                width : diameter+'px',
                height : diameter+'px',
                borderRadius: '50%',
                backgroundColor : color,
                margin : 'auto'
            }}
        >
            <div></div>
        </div>
    );

    return (<div
        key = {blockId}
        style = {style}
        onMouseEnter = {(e)=>{if(onEnterPostIt){onEnterPostIt(blockId)}}}
        onMouseLeave = {(e)=>{if(onLeavePostIt){onLeavePostIt(blockId)}}}
        onMouseDown={onMouseDownOnTitle}
        onContextMenu = {onContextmenu}
        onDoubleClick={onTitleDoubleClick}
    >
        {content}
        {/* <div
            key = {1}
            style ={{
                width : '100%',
                backgroundColor : color,
                cursor : 'move',
                position : 'relative',
                fontSize : 9 * zoom,
            }}

        >{text}</div> */}
        {/* <AutosizeTextArea 
            scriptId = {scriptId}
            subscriptId = {subscriptId}
            className="p-0 m-0"
            initial={value}  
            onChange={(value)=>onChanged(value)}
            fontSize = { 0.6 * Math.pow(zoom,0.5) }
        /> */}
        <div
            key = {2}
            style={{
                position:'absolute',
                width:'0.5em',
                height : '100%',
                top:0,
                right :0,
                cursor :'ew-resize',
                // backgroundColor:'red',
            }}
            onMouseDown={onResizeMouseDown}
        >
            <div></div>
        </div>
    </div>)

}

function getSingleSelected(selected){
    var selectedBlockId = 0;
    var selectedCount = 0;
    var selectedBlockIds = [];
    $.each(selected,(blockId)=>{
        if (selectedCount){
            selectedBlockId = 0;
        } else {
            selectedBlockId = blockId;
        }
        selectedBlockIds.push(blockId);
        selectedCount++;
    });
    return {selectedBlockIds,selectedBlockId,selectedCount};
}

function RowSummary({scriptId,subscriptId,targetBlockId,onSelectionRequested,onBlockFocussed}){
    var targetBlock = getBlock(scriptId,targetBlockId);

    var orderedIds = modelStore.useSelector(state=>{
        return state.access(["model","Script",scriptId,"subscripts",subscriptId,"orderedIds"],[]);
    },subscriptId);

    var targetGridRow = getGridRow(targetBlock?.meta?.top);
    var blocks=[];
    var sequenceBlocks = [];
    var targetSequenceBlock;
    var headerBlocks = [];
    var blocks = {};
    $.each(orderedIds,(b,bId)=>{
        var block = getBlock(scriptId,bId);
        var blockCol = getGridColumn(block.meta.left);
        var blockRow = getGridRow(block.meta.top);
        if (block.meta.isHeader) {
            headerBlocks.push(block);
        } else if (block.meta.isSequence) {
            sequenceBlocks.push(block)
            if ( blockRow == targetGridRow){
                    targetSequenceBlock = block;
            }
        } else if (blockRow==targetGridRow){
            blocks[blockCol]=block;
        }
    })
    headerBlocks.sort((a,b)=>{
        return getGridColumn(a.meta.left) - getGridColumn(b.meta.left);
    });
    sequenceBlocks.sort((a,b)=>{
        return getGridRow(a.meta.top) - getGridRow(b.meta.top);
    });

    var blockEditors=[];
    blockEditors.push(<h3>Sequence</h3>);
    if (targetSequenceBlock){
        blockEditors.push(createElement(BlockEditor,{
            blockId : targetSequenceBlock.id,
            key : targetSequenceBlock.id,
            bold : true,
            editTitle : true,
        }));
    }
    $.each(headerBlocks,(b,headerBlock)=>{
        ((headerBlock)=>{
            var headerBLockCol = getGridColumn(headerBlock.meta.left);
            var block = blocks[headerBLockCol];
            var blockCol = getGridColumn(block?.meta?.left??0);
            blockEditors.push(createElement('div',{
                onDoubleClick : ()=>{
                    onSelectionRequested(headerBlock.id);
                },
                children : [headerBlock.text,
                    <div
                        style = {{
                            position : 'absolute',
                            top : 0,
                            right :'10px',
                            cursor : 'pointer',
                        }}
                        onClick = {()=>{
                            if (!block){
                                makeAndExecuteInsertBlockUpdate(
                                    scriptId,subscriptId,0,{
                                        type : "postit",
                                        text : "",
                                        meta : {
                                            left : headerBLockCol * gridColWidth,
                                            top : targetGridRow * gridRowHeight,
                                            width : gridColWidth,                                            description : "",
                                        }
                                    }
                                );
                            } else {
                                // var ii=0;
                                makeAndExecuteDeleteArbitraryBlocks(scriptId,subscriptId,block.id);
                            }
                        }}
                    >{!block?"add":"clean"}</div>
                ],
                position : 'relative',
                key : headerBlock.id+"_sequence",
                style : {marginBottom:'2px',fontSize:'0.8em',backgroundColor:'#F0F0F0',position:'relative'}
            }));

            if (blocks[headerBLockCol]){        
                blockEditors.push(createElement(BlockEditor,{
                    blockId : block.id,
                    key : block.id,
                }));
            }
        })(headerBlock);
    })
    
    return (<div
        style={{backgroundColor:'#F8FFF*'}}
    >
        {blockEditors}
    </div>)
    
    function BlockEditor({blockId,bold,editTitle}){
        
        var block = modelStore.useSelector(state=>{
            return getBlock(scriptId,blockId);
        },blockId);

        function onChanged(newValue){
            onMetaChanged(scriptId,subscriptId,block,'description',newValue)
        }
        function onTitleChanged(newValue){
            onTextChanged(scriptId,subscriptId,blockId,newValue);
        }
        return(<div
            key={blockId}
        >
            {editTitle?(<AutosizeTextArea 
                key ={1}
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                className="p-0 m-0"
                initial={block?.text??""}  
                onChange={(value)=>onTitleChanged(value)}
                style = {{
                    marginBottom : '0.5em',
                }}
                fontSize = {bold?1.3:1}
            />):null}
            {/* {block.text} */}
            {/* <br key ={2}style={{}}/> */}
            <div style={{height:'0.25em'}}><div></div></div>
            <AutosizeTextArea 
                key ={3}
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                className="p-0 m-0"
                initial={block?.meta?.description??""}  
                onChange={(value)=>onChanged(value)}
                // fontSize = { 0.6 * Math.pow(zoom,0.5) }
                style = {{
                    marginTop : '1em',
                }}
            />
            <div style={{height:'0.25em'}}><div></div></div>
        </div>)
    }
}
//ColSummaryTable
function BlockMetaDetails({scriptId,subscriptId,blockId,onSelectionRequested,onBlockFocussed}){

    var targetBlock = getBlock(scriptId,blockId);

    if (isArray(blockId)){
        var allHeaders=true;
        $.each(blockId,(b,bid)=>{
            var block = getBlock(scriptId,bid);
            if (!block?.meta?.isHeader){
                allHeaders = false;
            }
        })
        if (!allHeaders){
            return null;
        }

        return (<div
            style = {{
                width : (blockId.length * 20 + 2)+'em',
                height : '100%',
                overflow : 'auto',
                position : 'absolute',
                right : 0,
                top : 0,
                border : 'solid 1px grey',
                padding : '1em',
                backgroundColor :'white',
            }}
            className = "noScrollBar"

        >
            <ColSummaryTable scriptId={scriptId} subscriptId={subscriptId} targetBlockIds={blockId} onSelectionRequested={onSelectionRequested} onBlockFocussed={onBlockFocussed} />
        </div>)

    } else if (targetBlock?.meta?.isHeader){

        return (<div
            style = {{
                width : '20em',
                height : '100%',
                overflow : 'auto',
                position : 'absolute',
                right : 0,
                top : 0,
                border : 'solid 1px grey',
                padding : '1em',
                backgroundColor :'white',
            }}
            className = "noScrollBar"

        >
            <ColSummary scriptId={scriptId} subscriptId={subscriptId} targetBlockId={blockId} onSelectionRequested={onSelectionRequested} onBlockFocussed={onBlockFocussed} />
        </div>)
    } else if (targetBlock?.meta?.isSequence){
        return (<div
            style = {{
                width : '20em',
                height : '100%',
                overflow : 'auto',
                position : 'absolute',
                right : 0,
                top : 0,
                border : 'solid 1px grey',
                padding : '1em',
                backgroundColor :'white',
            }}
            className = "noScrollBar"

        >
            <RowSummary scriptId={scriptId} subscriptId={subscriptId} targetBlockId={blockId} onSelectionRequested={onSelectionRequested} onBlockFocussed={onBlockFocussed}/>
        </div>)
    } else {
        return (<BlockDetails scriptId={scriptId} subscriptId={subscriptId} blockId={blockId} />);
    }

}

function BlockDetails({scriptId,subscriptId,blockId}){

    var orderedIds = modelStore.useSelector(state=>{
        return state.access(["model","Script",scriptId,"subscripts",subscriptId,"orderedIds"],[]);
    },subscriptId);

    function onChanged(newValue){
        onMetaChanged(scriptId,subscriptId,block,'description',newValue)
    }
    function onTitleChanged(newValue){
        onTextChanged(scriptId,subscriptId,blockId,newValue);
    }
    function onGroupChange(newValue){
        if (blockId){
            onMetaChanged(scriptId,subscriptId,blockId,"group",newValue);
        }
    }
    var meta = modelStore.useSelector(state=>{
        return getBlock(scriptId,blockId)?.meta;
    },blockId);
    
    
    var targetBlock = getBlock(scriptId,blockId);
    var targetGridCol = getGridColumn(targetBlock?.meta?.left??0);
    var targetGridRow = getGridRow(targetBlock?.meta?.top??0);
    
    var sequenceBlocks=[];
    var topRow=10000;
    var headerAxisBlock = null;

    $.each(orderedIds,(b,bId)=>{
        var block = getBlock(scriptId,bId);
        var blockRow = getGridRow(block.meta.top);
        var blockCol = getGridColumn(block.meta.left);
        
        if (targetGridCol == blockCol){
            if (blockRow<topRow){
                topRow = blockRow;
                headerAxisBlock = block;
            }
        }
        if (block.meta.isSequence){
            sequenceBlocks.push(block);
        }
    });
    sequenceBlocks.sort((a,b)=>{
        return getGridRow(a.meta.top) - getGridRow(b.meta.top);
    });
    var sequenceAxisBlock = null;
    $.each(sequenceBlocks,(r,sequenceBlock)=>{
        var sequenceRow = getGridRow(sequenceBlock.meta.top);
        if (sequenceRow<=targetGridRow){
            sequenceAxisBlock=sequenceBlock;
        }
    })

    var headerAxis = headerAxisBlock?(
        <div style={{textAlign:'left'}} key="ha" >{headerAxisBlock.text}</div>
    ):null
    
    var sequenceAxis = sequenceAxisBlock?(
        <div style={{textAlign:'left'}} key="sa" >{sequenceAxisBlock.text}</div>
    ):null

    var element =null;
    if (blockId){
        var block = getBlock(scriptId,blockId);
        
        element = (<div
            key ={'blkdet'}
            style = {{
                width : '20em',
                top : '1em',
                right : '1em',
                backgroundColor : 'white',
                border : 'solid 1px grey',
                position : 'absolute',
                padding : '1em'
            }}
        >
            {headerAxis}
            {sequenceAxis}
            <hr key ="a"/>
            <AutosizeTextArea 
                key ={1}
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                className="p-0 m-0"
                initial={ block?.text??""}  
                onChange={(value)=>onTitleChanged(value)}
                style = {{
                    marginBottom : '1em',
                    border : "1px solid grey",
                }}
                // fontSize = { 0.6 * Math.pow(zoom,0.5) }
            />
            {/* {block.text} */}
            <br key ={2}/>
            <AutosizeTextArea 
                key ={3}
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                className="p-0 m-0"
                initial={block?.meta?.description??""}  
                onChange={(value)=>onChanged(value)}
                // fontSize = { 0.6 * Math.pow(zoom,0.5) }
                style = {{
                    marginTop : '1em',
                    border : "1px solid grey",
                }}
            />
            {/* <br/> */}
            {/* <AutosizeTextArea 
                key ={4}
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                className="p-0 m-0"
                initial={block?.meta?.group??""}  
                onChange={(value)=>onGroupChange(value)}
                // fontSize = { 0.6 * Math.pow(zoom,0.5) }
                style = {{
                    marginTop : '1em',
                }}
            />
            <br/> */}
            <ToggleButton 
                keh = "isq"
                value = {!!(meta?.isSequence??"")}
                text = "Sequence"
                className="my-1"
                onChange = {(()=>onMetaChanged(scriptId,subscriptId,blockId,"isSequence",!(meta?.isSequence??"")))}
            />
            <ToggleButton 
                keh = "ish"
                value = {!!(meta?.isHeader??"")}
                text = "Header"
                className="my-1"
                onChange = {(()=>onMetaChanged(scriptId,subscriptId,blockId,"isHeader",!(meta?.isHeader??"")))}
            />
            {/* <input type="text" value={block?.meta?.group??""} onChange={onGroupChange} style={{width:'100%'}} /> */}
        </div>)
    }
    
    return element;
}

function ColSummaryTable({scriptId,subscriptId,targetBlockIds,onSelectionRequested,onBlockFocussed}){

    var orderedIds = modelStore.useSelector(state=>{
        return state.access(["model","Script",scriptId,"subscripts",subscriptId,"orderedIds"],[]);
    },subscriptId);

    var targets = {}

    $.each(targetBlockIds,(b,targetBlockId)=>{

        var targetBlock = getBlock(scriptId,targetBlockId);

        var target = {
            targetBlock  : targetBlock ,
            thrulineBlock  :  null,
            targetGridCol  :  getGridColumn(targetBlock?.meta?.left),
            blocks : [],
            blocksByRow  :  {},
        };

        targets[targetBlockId]=target;
    })

    var sequenceBlocks={};
    var topRow=10000;
    var bottomRow=-10000;

    $.each(orderedIds,(b,bId)=>{
        var block = getBlock(scriptId,bId);
        var blockRow = getGridRow(block.meta.top);
        
        $.each(targetBlockIds,(b,targetBlockId)=>{
            var target = targets[targetBlockId];

            if (target.targetGridCol == getGridColumn(block.meta.left)){
                if (block.meta.isHeader){
                    target.thrulineBlock = block;
                } else {
                    target.blocks.push(block);
                    target.blocksByRow[blockRow]=block;
                    target.topRow = Math.min(target.topRow,blockRow);
                    target.bottomRow = Math.max(target.bottomRow,blockRow);
                }
            }
        })

        if (block.meta.isSequence){
            sequenceBlocks[blockRow]=block;
            topRow = Math.min(topRow,blockRow);
            bottomRow = Math.max(bottomRow,blockRow);
        }

    });

    $.each(targetBlockIds,(b,targetBlockId)=>{
        var target = targets[targetBlockId];

        target.blocks.sort((a,b)=>{
            return getGridRow(a.meta.top) - getGridRow(b.meta.top);
        });
            
    })

    var rows = [];

    var headerCells=[];
    $.each(targetBlockIds,(b,targetBlockId)=>{
        var target = targets[targetBlockId];

        headerCells.push(<td
            style ={{
                width:'20em',
                verticalAlign: 'top',
            }}
        >
            <ColBlockEditor
                scriptId = {scriptId}
                subscriptId = {subscriptId}
                blockId = {target.thrulineBlock.id}
                key = {target.thrulineBlock.id}
                bold = {true}
                editTitle = {true}
            />
        </td>)
    });

    rows.push(<tr>{headerCells}</tr>);


    for (var row = topRow;row<=bottomRow;row++){
        var sequenceBlock = sequenceBlocks[row];

        var cells = [];

        $.each(targetBlockIds,(b,targetBlockId)=>{
            var target = targets[targetBlockId];

            var block = target.blocksByRow[row];

            var blockEditors = [];
            if (sequenceBlock){
                
                (function(row,block,sequenceBlock){
                    blockEditors.push(createElement('div',{
                        onDoubleClick : ()=>{onSelectionRequested(sequenceBlock.id)},
                        children : [sequenceBlock.text,
                            <div
                                style = {{
                                    position : 'absolute',
                                    top : 0,
                                    right :'10px',
                                    cursor : 'pointer',
                                }}
                                onClick = {()=>{
                                    if (!block){
                                        makeAndExecuteInsertBlockUpdate(
                                            scriptId,subscriptId,0,{
                                                type : "postit",
                                                text : "",
                                                meta : {
                                                    top : row * gridRowHeight,
                                                    left : target.targetGridCol * gridColWidth,
                                                    width : gridColWidth,                                            
                                                    description : "",
                                                }
                                            }
                                        );
                                    } else {
                                        // var ii=0;
                                        makeAndExecuteDeleteArbitraryBlocks(scriptId,subscriptId,block.id);
                                    }
                                }}
                            >{!block?"add":"clean"}</div>
                        ],
                        position : 'relative',
                        key : sequenceBlock.id+"_sequence",
                        style : {marginBottom:'2px',fontSize:'0.8em',backgroundColor:'#F0F0F0',position:'relative'}
                    }));
                })(row,block,sequenceBlock);

            } 
            if (block){
                blockEditors.push(createElement(ColBlockEditor,{
                    scriptId,
                    subscriptId,
                    blockId : block.id,
                    key : block.id,
                    onFocussed : onBlockFocussed
                }));
            }

            cells.push(<td
                style ={{
                    width:'20em',
                    verticalAlign: 'top',
                }}
            >{blockEditors}</td>)
            
        });

        rows.push(<tr>{cells}</tr>);

    }

    
    return (<table
        style = {{
            tableLayout:'fixed',
            width : (targetBlockIds.length * 20)+'em'
        }}
    >
        <tbody>
            {rows}
        </tbody>
    </table>)
}

function ColSummary ({scriptId,subscriptId,targetBlockId,onSelectionRequested,onBlockFocussed}){

    var orderedIds = modelStore.useSelector(state=>{
        return state.access(["model","Script",scriptId,"subscripts",subscriptId,"orderedIds"],[]);
    },targetBlockId);

    var targetBlock = getBlock(scriptId,targetBlockId);
    var thrulineBlock = null;
    var targetGridCol = getGridColumn(targetBlock?.meta?.left);
    var blocks=[];
    var sequenceBlocks={};
    var blocksByRow = {};
    var topRow=10000;
    var bottomRow=-10000;

    $.each(orderedIds,(b,bId)=>{
        var block = getBlock(scriptId,bId);
        var blockRow = getGridRow(block.meta.top);
        
        if (targetGridCol == getGridColumn(block.meta.left)){
            if (block.meta.isHeader){
                thrulineBlock = block;
            } else {
                blocks.push(block);
                blocksByRow[blockRow]=block;
                topRow = Math.min(topRow,blockRow);
                bottomRow = Math.max(bottomRow,blockRow);
            }
        }
        if (block.meta.isSequence){
            sequenceBlocks[blockRow]=block;
            topRow = Math.min(topRow,blockRow);
            bottomRow = Math.max(bottomRow,blockRow);
        }

    });
    blocks.sort((a,b)=>{
        return getGridRow(a.meta.top) - getGridRow(b.meta.top);
    });
    var blockEditors=[];
    blockEditors.push(<h3>Through Line</h3>);
    
    blockEditors.push(createElement(ColBlockEditor,{
        scriptId,
        subscriptId,
        blockId : thrulineBlock.id,
        key : thrulineBlock.id,
        bold : true,
        editTitle : true,
    }));
    for (var row = topRow;row<=bottomRow;row++){
        var sequenceBlock = sequenceBlocks[row];
        var block = blocksByRow[row];
        if (sequenceBlock){
             
            (function(row,block,sequenceBlock){
                blockEditors.push(createElement('div',{
                    onDoubleClick : ()=>{onSelectionRequested(sequenceBlock.id)},
                    children : [sequenceBlock.text,
                        <div
                            style = {{
                                position : 'absolute',
                                top : 0,
                                right :'10px',
                                cursor : 'pointer',
                            }}
                            onClick = {()=>{
                                if (!block){
                                    makeAndExecuteInsertBlockUpdate(
                                        scriptId,subscriptId,0,{
                                            type : "postit",
                                            text : "",
                                            meta : {
                                                top : row * gridRowHeight,
                                                left : targetGridCol * gridColWidth,
                                                width : gridColWidth,                                            
                                                description : "",
                                            }
                                        }
                                    );
                                } else {
                                    // var ii=0;
                                    makeAndExecuteDeleteArbitraryBlocks(scriptId,subscriptId,block.id);
                                }
                            }}
                        >{!block?"add":"clean"}</div>
                    ],
                    position : 'relative',
                    key : sequenceBlock.id+"_sequence",
                    style : {marginBottom:'2px',fontSize:'0.8em',backgroundColor:'#F0F0F0',position:'relative'}
                }));
            })(row,block,sequenceBlock);

        } 
        if (block){
            blockEditors.push(createElement(ColBlockEditor,{
                scriptId,
                subscriptId,
                blockId : block.id,
                key : block.id,
                onFocussed : onBlockFocussed
            }));
        }
    }

    return (<div>
        {blockEditors}
    </div>)
}

function ColBlockEditor({scriptId,subscriptId,blockId,bold,editTitle,onFocussed}){
    var block = modelStore.useSelector(state=>{
        return getBlock(scriptId,blockId);
    },blockId)
    function onChanged(newValue){
        onMetaChanged(scriptId,subscriptId,block,'description',newValue)
    }
    function onTitleChanged(newValue){
        onTextChanged(scriptId,subscriptId,blockId,newValue);
    }
    return(<div
        key={blockId}
        tabIndex={-1}
        onFocus={()=>{
            if (onFocussed){
                onFocussed(blockId)
            }
        }}
    >
        {editTitle?(<AutosizeTextArea 
            key ={1}
            scriptId = {scriptId}
            subscriptId = {subscriptId}
            className="p-0 m-0"
            initial={block?.text??""}  
            onChange={(value)=>onTitleChanged(value)}
            style = {{
                marginBottom : '0.5em',
            }}
             fontSize = { bold?1.3:1}
        />):null}
        {/* {block.text} */}
        {/* <br key ={2}style={{}}/> */}
        <div style={{height:'0.5em'}}><div></div></div>
        <AutosizeTextArea 
            key ={3}
            scriptId = {scriptId}
            subscriptId = {subscriptId}
            className="p-0 m-0"
            initial={block?.meta?.description??""}  
            onChange={(value)=>onChanged(value)}
            // fontSize = { 0.6 * Math.pow(zoom,0.5) }
            style = {{
                marginTop : '1em',
            }}
        />
        <div style={{height:'1em'}}><div></div></div>
    </div>)
}


